import { render, staticRenderFns } from "./btn-group.vue?vue&type=template&id=5d83e3cf&scoped=true"
import script from "./btn-group.vue?vue&type=script&lang=js"
export * from "./btn-group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d83e3cf",
  null
  
)

export default component.exports